import React, { useEffect, useReducer, useState } from 'react';
import Modal from 'react-modal';
import API, { graphqlOperation } from '@aws-amplify/api';
import { Authenticator, SignIn, Greetings, ConfirmSignIn, RequireNewPassword, VerifyContact, ForgotPassword, Loading } from 'aws-amplify-react';
import PubSub from '@aws-amplify/pubsub';
import Auth from '@aws-amplify/auth';
import Storage from '@aws-amplify/storage';
import HashLoader from 'react-spinners/HashLoader';

import { Row, Col, Form, FormControl, Button, ButtonToolbar, InputGroup } from 'react-bootstrap';

import { createItem, updateItem, deleteItem } from './graphql/mutations';
import { listItems } from './graphql/queries';
import { onCreateItem, onUpdateItem, onDeleteItem } from './graphql/subscriptions';

import Img from 'react-image'

import awsconfig from './aws-exports';

import DetailView from './detailView';

import ReactGA from 'react-ga';
ReactGA.initialize('G-5LSJTQCHMC');

Modal.setAppElement('#root')

API.configure(awsconfig);
PubSub.configure(awsconfig);
Auth.configure(awsconfig);


// Action Types
const QUERY = 'QUERY';
const SUBSCRIPTION = 'SUBSCRIPTION';
const APPEND = 'APPEND';

function sorter(a,b){
  if (a.name.toLowerCase() > b.name.toLowerCase()) 
    return 1; 
  else if(a.name.toLowerCase() < b.name.toLowerCase()) 
    return -1; 
  else return 0;
}

const reducer = (state, action) => {
  switch (action.type) {
    case QUERY:
      return { ...state, items: action.items.sort(sorter) };
    case APPEND:
      return { ...state, items: state.items.concat(action.items).sort(sorter) };
    case SUBSCRIPTION:
      return { ...state, items: [...state.items, action.item] }
    default:
      return state;
  }
};

const cardCss = {
  width: "100%",
  backgroundColor: "lightyellow",
  borderRadius: 5,
  margin: 10,
  padding: 10,
  border: "1px solid gray"
}

let timeout;

function App() {


  const [state, dispatch] = useReducer(reducer, { items: [] });
  const [modalEditIsOpen, setModalEditIsOpen] = useState(false);
  const [modalViewIsOpen, setModalViewIsOpen] = useState(false);
  const [itemValues, setItemValues] = useState({});
  const [searchValue, setSearchValue] = useState("");
  const [searchDisplayText, setsearchDisplayText] = useState("");
  const [attemptLogin, setAttemptLogin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState(false);

  async function persistData(values) {

    if (values.createNew) {
      delete values.createNew;
      delete values.deleteItem;
      await API.graphql({ query: createItem, variables: { input: values }, authMode: "AMAZON_COGNITO_USER_POOLS" });
    } else if (values.deleteItem){
      delete values.createNew;
      delete values.deleteItem;
      await API.graphql({ query: deleteItem, variables: { input: values }, authMode: "AMAZON_COGNITO_USER_POOLS" });
    } else {
      delete values.createNew;
      delete values.deleteItem;
      await API.graphql({ query: updateItem, variables: { input: values }, authMode: "AMAZON_COGNITO_USER_POOLS" });
    }

    closeModal();
  }

  
  function delaySearch(value){

    setsearchDisplayText(value);

    // Clear the timeout if it has already been set.
    // This will prevent the previous task from executing
    // if it has been less than <MILLISECONDS>
    clearTimeout(timeout);

    // Make a new timeout set to go off in 800ms
    timeout = setTimeout(function () {
        setSearchValue(value)
    }, 1500);

  }
  
  async function getImageUrl(item) {

    let key = item.id + "/product.jpg";
    const url = await Storage.get(key);
    return url;
  }

  async function openModal(item) {

    setItemValues(item);

    // check if valid session AND user has admin role
    if (isAdmin)
      setModalEditIsOpen(true);
    else
      setModalViewIsOpen(true);

  }
  function afterOpenModal() {
  }
  function closeModal() {
    setModalEditIsOpen(false);
    setModalViewIsOpen(false);
  }




  let session, usr, localIsAdmin; // localIsAdmin so that updating state doesn't trigger useEffect again.
  // check session to know if we are viewing or editing
  // then: load the data,
  async function getData(nextToken) {

  
    setLoadingMessage("Loading...")

    try {
      session = await Auth.currentSession();
    } catch (e) {
      session = null;
    }

    if (session) {
      usr = await Auth.currentAuthenticatedUser()

      if (usr && usr.signInUserSession && usr.signInUserSession.accessToken && usr.signInUserSession.accessToken.payload && usr.signInUserSession.accessToken.payload["cognito:groups"]) {
        if (usr.signInUserSession.accessToken.payload["cognito:groups"].includes("Admins")) {
          localIsAdmin = true;
          setIsAdmin(true);
        }
      }
    }


    let filter;
    if (searchValue) {
      filter = {
        filter: {
          or: [
            {
              name: {
                contains: searchValue
              }
            },
            {
              description: {
                contains: searchValue
              }
            },
            {
              category: {
                contains: searchValue
              }
            }
          ]
        }
      }
    } else {
      filter = null;
    }

    const itemData = await API.graphql({ query: listItems, variables: { nextToken: nextToken, ...filter, limit: 500 }, authMode: localIsAdmin ? "AMAZON_COGNITO_USER_POOLS" : "AWS_IAM" });

    let enrichedItems = itemData.data.listItems.items;
    for (var i = 0; i < enrichedItems.length; i++) {
      enrichedItems[i]["imageUrl"] = await getImageUrl(enrichedItems[i]);
    }

    if(!enrichedItems.length){
      setLoadingMessage("No items found.")
    }

    dispatch({ type: nextToken ? APPEND : QUERY, items: enrichedItems });

    if (itemData.data.listItems.nextToken) {
      getData(itemData.data.listItems.nextToken);
    }

  }

  useEffect(() => {

    getData().then(() => {
      if (localIsAdmin) {
        const subscriptionCreate = API.graphql(graphqlOperation(onCreateItem)).subscribe({
          next: (eventData) => {
            getData();
          }
        });

        const subscriptionUpdate = API.graphql(graphqlOperation(onUpdateItem)).subscribe({
          next: (eventData) => {
            getData();
          }
        });

        const subscriptionDelete = API.graphql(graphqlOperation(onDeleteItem)).subscribe({
          next: (eventData) => {
            getData();
          }
        });

        return () => { subscriptionCreate.unsubscribe(); subscriptionUpdate.unsubscribe(); subscriptionDelete.unsubscribe(); }
      }
      else {
        return {};
      }
    })
  }, [searchValue]);

  ReactGA.pageview(window.location.pathname + window.location.search);

  return (
    <div className="App" style={{ margin: 20 }}>

      <Greetings />


      <ButtonToolbar style={{ flexDirection: "row", justifyContent: "center", marginBottom: 30 }}>
        { isAdmin && 
          <Button variant="primary" onClick={openModal}>+ New Item</Button>
        }

        <div style={{ marginLeft: 20, verticalAlign: "center" }}>
          <Form.Control type="text" placeholder="Search" value={searchDisplayText} onChange={(event) => delaySearch(event.target.value)} />
        </div>
      </ButtonToolbar>

      <Modal
        className="Modal"
        isOpen={attemptLogin}
      >
        <Button variant="secondary" type="submit" style={{ float: "right" }} onClick={() => setAttemptLogin(false)}>Close</Button>

        <Authenticator
          authState=""
          // hide all the default components
          hideDefault={true}
          // Pass in an aws-exports configuration
          amplifyConfig={awsconfig}
          onStateChange={(authState) => { setAttemptLogin(authState !== "signedIn"); setIsAdmin(authState === "signedIn"); }}
        >

          <SignIn />
          <ConfirmSignIn />
          <RequireNewPassword />
          <VerifyContact />
          <ForgotPassword />
          <Loading />
        </Authenticator>
      </Modal>

      <Modal
        className="Modal"
        isOpen={modalEditIsOpen || modalViewIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
      >
        <DetailView itemValues={itemValues} onSubmit={persistData} allowEdits={modalEditIsOpen} onDelete={persistData} />
      </Modal>


      <h1>Lending Library Catalog</h1>

      <div>
        {state.items.length > 0 ?
          state.items.map((item) =>
            <Row style={cardCss} onClick={() => { openModal(item) }} key={item.id}>
              <Col style={{ textAlign: "left" }}>
                <span style={{ marginRight: 10 }}><b>Name:</b> {item.name}</span><br />
                <span style={{ marginRight: 10 }}><b>Cost:</b> ${(item.cost || 0).toFixed(2)}</span><br />
                <span style={{ marginRight: 10 }}><b>Vendor:</b> {item.vendor}</span><br />
                <span style={{ marginRight: 10 }}><b>Category:</b> {item.category}</span><br />
              </Col>
              <Col style={{ textAlign: "left" }}>
                <span style={{ marginRight: 10 }}>{item.description}</span>
              </Col>
              {/*<Col style={{ textAlign: "right" }}>
                <Img src={item.imageUrl} style={{ height: 150 }} />
              </Col>*/}
            </Row>
          ) :
            <div>
              <b>{loadingMessage}</b>
              <HashLoader css={{marginTop:30, position: "fixed", left: "50%", transform: "translate(-50%, -50%)"}} sizeUnit={"px"} size={40} loading={loadingMessage === "Loading..."} />
            </div>
        }
      </div>

      {!isAdmin &&
        <Button variant="secondary" type="submit" style={{ float: "right" }} onClick={() => setAttemptLogin(true)}>Login</Button>
      }

    </div>
  )

};

//export default withAuthenticator(App);
export default App;



// WEBPACK FOOTER //
// ./src/App.js